import axios from "axios";
import isEmpty from "lodash/isEmpty";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

import { userLogout, userCheckLogin } from "./user";
import { clearCheckout } from "./checkout";

export const billingAddressesLoading = () => {
	return {
		type: "BILLING_ADDRESSES_LOADING"
	};
};

export const billingAddressesError = err => {
	return {
		type: "BILLING_ADDRESSES_ERROR",
		err
	};
};

export const billingAddressesSuccess = payload => {
	return {
		type: "BILLING_ADDRESSES_SUCCESS",
		payload: payload
	};
};

export function getBillingAddresses() {
	return (dispatch, getState) => {
		dispatch(billingAddressesLoading());

		dispatch(userCheckLogin("customer")).then(() => {
			let token = "";
			if (getState().user.customer) token = getState().user.customer.token;

			let AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

			return axios
				.get(REACT_APP_API_URL + "customer-billing-addresses/", { headers: AUTH_HEADER })
				.then(response => {
					// Error explicitly set
					if (!isEmpty(response.data.errors)) {
						dispatch(billingAddressesError(response.data.errors));

						// Error status
					} else if (!!response.data.status && response.data.status !== 200) {
						// Log user out if token expired, token, etc
						if (response.data.status === 403) {
							dispatch(clearCheckout());
							dispatch(userLogout("customer"));
						}

						dispatch(billingAddressesError({ general: response.data.message }));

						// Success
					} else {
						dispatch(billingAddressesSuccess(response.data));
					}
				})
				.catch(err => {
					console.log("getBillingAddresses error:", err.response.statusText);
					dispatch(billingAddressesError({ general: err.response.statusText }));
				});
		});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/billingAddress.js